import { MessageType } from 'root/services/fileHelpers/consts';

export const isError = (type: MessageType) =>
  type === MessageType.SEND_ORDER_ERROR ||
  type === MessageType.UPLOAD_IMAGE_ERROR ||
  type === MessageType.ROTATE_IMAGE_ERROR;

export const isSuccess = (type: MessageType) =>
  type === MessageType.SEND_ORDER_SUCCESS;
